<template>
  <div id="ProductBundles">
    <v-card max-width="100%" outlined>
      <v-row no-gutters class="align-center">
        <v-card-title class="text-h4"> Product Bundles </v-card-title>
        <v-spacer />
        <div
          class="d-flex flex-row px-4 flex-wrap align-center"
          style="gap: 24px"
        >
          <v-btn
            color="primary"
            class=""
            @click="createItem"
            :disabled="offline || savingSelectedProductBundles"
          >
            New Bundle
          </v-btn>
        </div>
      </v-row>

      <v-row class="px-4">
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="productBundlesDataTableSearch"
            append-icon="mdi-magnify"
            label="Search"
            @input="changeProductBundlesSearchQuery"
          >
          </v-text-field>
        </v-col>
        <v-col cols="6" sm="4">
          <v-combobox
            class="productBundlesSearchInputCSS pt-2"
            v-model="productBundlesSearchTags"
            label="Tags"
            multiple
            chips
            dense
            @change="changeProductBundlesSearchQuery"
            min-height="36px"
            deletable-chips
            clearable
            :items="syncedProductTagArray"
            item-text="name"
            :return-object="false"
            item-value="id"
          ></v-combobox>
        </v-col>
        <v-col cols="6" sm="4">
          <v-menu
            v-model="searchProductBundleCategoriesMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            :nudge-bottom="-12"
            :rounded="false"
          >
            <template v-slot:activator="{ on }">
              <div @click="toggleMenu">
                <v-combobox
                  class="productBundlesSearchInputCSS pt-2"
                  :value="computedProductBundlesSearchCategories"
                  label="Categories"
                  multiple
                  chips
                  dense
                  min-height="36px"
                  clearable
                  v-on="on"
                  readonly
                  @click:clear="productBundlesDataTableSearchCategories = []"
                ></v-combobox>
              </div>
            </template>
            <v-card>
              <v-card-text>
                <v-treeview
                  :items="categoryTree"
                  color="primary"
                  selected-color="primary"
                  selectable
                  item-key="id"
                  open-on-click
                  selection-type="independent"
                  v-model="productBundlesDataTableSearchCategories"
                  @input="changeProductBundlesSearchQuery"
                ></v-treeview>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>

      <div v-if="selectedProductBundles.length > 0">
        <v-card-title class="text-h5 pb-4 pt-0"> Bulk Edit </v-card-title>

        <div class="px-3 pb-3" style="max-width: 470px">
          <!-- <v-col class="pt-0" cols="12" sm="6" md="4"> -->
          <v-expansion-panels
            class="mb-3"
            style="justify-content: left"
            v-model="expBulkEditPanels"
          >
            <v-expansion-panel>
              <v-expansion-panel-header class="pa-2">
                <div class="d-flex align-center">
                  <v-icon class="mr-1"> mdi-star </v-icon>
                  <div>
                    <span> Feature</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                id="expPanelContent"
                color="grey lighten-3"
              >
                <v-row class="pa-3 d-flex" style="gap: 12px">
                  <v-btn
                    color="primary"
                    @click="featureProductBundles"
                    :disabled="offline || savingSelectedProductBundles"
                  >
                    <v-icon left> mdi-star </v-icon>Feature Product Bundles
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="unFeatureProductBundles"
                    :disabled="offline || savingSelectedProductBundles"
                  >
                    <v-icon left> mdi-star-outline </v-icon>Unfeature Product
                    Bundles
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="pa-2">
                <div class="d-flex align-center">
                  <v-icon class="mr-1">mdi-calendar</v-icon>
                  <div>
                    <span> Schedule</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                id="expPanelContent"
                color="grey lighten-3"
              >
                <v-row class="pa-3 d-flex align-center" style="gap: 12px">
                  <v-dialog
                    v-model="bulkEditDateTimeDialog"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedBulkEditPublishDate"
                        readonly
                        label="Publish Date"
                        v-bind="{ ...attrs, ...$attrs }"
                        v-on="on"
                        clearable
                        @click:clear="updateBulkEditPublishDateTime('clear')"
                      ></v-text-field>
                    </template>
                    <v-card class="t-datetime-picker white">
                      <v-toolbar height="36" color="primary" dark flat>
                        <v-tabs v-model="bulkEditDateTimeTab" grow height="36">
                          <v-tabs-slider color="white"></v-tabs-slider>
                          <v-tab href="#date">
                            <v-icon>mdi-calendar</v-icon>
                          </v-tab>
                          <v-tab href="#time">
                            <v-icon>mdi-clock</v-icon>
                          </v-tab>
                          <v-btn
                            depressed
                            text
                            class="rounded-0"
                            @click="closeBulkEditDateTimeDialog"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </v-tabs>
                      </v-toolbar>

                      <v-tabs-items v-model="bulkEditDateTimeTab">
                        <v-tab-item value="date">
                          <v-date-picker
                            v-model="bulkEditPublishDate"
                            @change="updateBulkEditPublishDateTime"
                            class="rounded-0"
                            @input="bulkEditDateTimeTab = 'time'"
                            full-width
                          >
                          </v-date-picker>
                        </v-tab-item>
                        <v-tab-item value="time">
                          <v-time-picker
                            :key="bulkEditDateTimeTab"
                            v-model="bulkEditPublishTime"
                            format="24hr"
                            class="rounded-0"
                            full-width
                            @change="updateBulkEditPublishDateTime"
                          >
                          </v-time-picker>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-dialog>
                  <v-btn
                    color="primary"
                    @click="scheduleProductBundles"
                    :disabled="
                      offline ||
                      savingSelectedProductBundles ||
                      !bulkEditPublishDateTime
                    "
                  >
                    Schedule
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="unScheduleProductBundles"
                    :disabled="offline || savingSelectedProductBundles"
                  >
                    Un-Publish
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="pa-2">
                <div class="d-flex align-center">
                  <v-icon class="mr-1">mdi-currency-usd</v-icon>
                  <div>
                    <span> Change Price</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                id="expPanelContent"
                color="grey lighten-3"
              >
                <v-row
                  class="pa-3 d-flex align-center justify-end"
                  style="gap: 12px"
                >
                  <v-text-field
                    v-model="bulkEditPriceChangeValue"
                    label="Price Change Value"
                    type="number"
                    prepend-icon="mdi-alpha-r"
                    @input="bulkEditPriceChangePercent = null"
                  ></v-text-field>

                  <v-text-field
                    v-model="bulkEditPriceChangePercent"
                    label="Price Change Percentage"
                    type="number"
                    append-icon="mdi-percent"
                    @input="bulkEditPriceChangeValue = null"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    @click="changeProductBundlesPrice('increase')"
                    :disabled="
                      offline ||
                      savingSelectedProductBundles ||
                      ((!bulkEditPriceChangePercent ||
                        bulkEditPriceChangePercent === '') &&
                        (!bulkEditPriceChangeValue ||
                          bulkEditPriceChangeValue === ''))
                    "
                  >
                    Increase
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="changeProductBundlesPrice('decrease')"
                    :disabled="
                      offline ||
                      savingSelectedProductBundles ||
                      ((!bulkEditPriceChangePercent ||
                        bulkEditPriceChangePercent === '') &&
                        (!bulkEditPriceChangeValue ||
                          bulkEditPriceChangeValue === ''))
                    "
                  >
                    Decrease
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="pa-2">
                <div class="d-flex align-center">
                  <v-icon class="mr-1">mdi-sale</v-icon>
                  <div>
                    <span>Discount</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                id="expPanelContent"
                color="grey lighten-3"
              >
                <v-row
                  class="pa-3 d-flex align-center justify-end"
                  style="gap: 12px"
                >
                  <v-text-field
                    v-model="bulkEditDiscountPercent"
                    label="Discount Percentage"
                    type="number"
                    append-icon="mdi-percent"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    @click="discountProductBundles"
                    :disabled="
                      offline ||
                      savingSelectedProductBundles ||
                      !bulkEditDiscountPercent ||
                      bulkEditDiscountPercent === ''
                    "
                  >
                    Discount
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>

      <div class="px-4">
        <v-data-table
          :footer-props="{
            showFirstLastPage: true,
          }"
          id="productBundlesDataTable"
          :headers="headers"
          :items="productBundles"
          :sort-desc.sync="sortDesc"
          :sort-by.sync="sortBy"
          :items-per-page.sync="productBundlesDataTableRowsPerPage"
          @update:items-per-page="queryProductBundles"
          :page.sync="productBundlesDataTablePageCount"
          @update:page="productBundlesDataTablePageCountUpdate"
          :server-items-length="productBundlesDataTableServerItemsLength"
          must-sort
          :loading="!syncedProductBundles && productBundles?.length === 0"
          loading-text="Loading Product Bundles..."
          no-data-text="No Product Bundles found"
          show-select
          v-model="selectedProductBundles"
        >
          <template v-slot:[`item.featured`]="{ item }">
            <v-icon v-if="item.featured">mdi-star</v-icon>
            <v-icon v-else>mdi-star-outline</v-icon>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            {{ formatPrice(item.price) }}
          </template>
          <template v-slot:[`item.discountPercentage`]="{ item }">
            {{ formatPercentage(item.discountPercentage) }}
          </template>
          <template v-slot:[`item.categoryId`]="{ item }">
            {{ formatCategoryId(item.categoryId) }}
          </template>
          <template v-slot:[`item.publishDate`]="{ item }">
            {{ formatDateTime(item.publishDate) }}
          </template>
          <template v-slot:[`item.updatedAt`]="{ item }">
            {{ formatDateTime(item.updatedAt) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              :disabled="offline || loading || savingSelectedProductBundles"
              @click="duplicateItem(item)"
            >
              mdi-content-copy
            </v-icon>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="offline || loading || savingSelectedProductBundles"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
              :disabled="offline || loading || savingSelectedProductBundles"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <v-dialog persistent v-if="dialog" v-model="dialog" max-width="800px">
      <v-card>
        <v-form ref="form" v-model="valid" @submit.prevent="save">
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.title"
                    label="Title"
                    :rules="formRules.title"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-checkbox
                    v-model="editedItem.featured"
                    label="Featured"
                  ></v-checkbox
                ></v-col>
                <v-col cols="6" sm="3">
                  <v-text-field
                    v-model="editedItem.price"
                    label="Price"
                    type="number"
                    prefix="R"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-text-field
                    v-model="editedItem.discountPercentage"
                    label="Discount"
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-text-field
                    :value="productBundleVat"
                    label="Vat (15%)"
                    type="number"
                    prefix="R"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-dialog v-model="datetimeDialog" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedProductBundlePublishDate"
                        readonly
                        label="Publish Date"
                        v-bind="{ ...attrs, ...$attrs }"
                        v-on="on"
                        clearable
                        @click:clear="
                          updateProductBundlePublishDateTime('clear')
                        "
                      ></v-text-field>
                    </template>
                    <v-card class="t-datetime-picker white">
                      <v-toolbar height="36" color="primary" dark flat>
                        <v-tabs v-model="dateTimeTab" grow height="36">
                          <v-tabs-slider color="white"></v-tabs-slider>
                          <v-tab href="#date">
                            <v-icon>mdi-calendar</v-icon>
                          </v-tab>
                          <v-tab href="#time">
                            <v-icon>mdi-clock</v-icon>
                          </v-tab>
                          <v-btn
                            depressed
                            text
                            class="rounded-0"
                            @click="closeDateTimeDialog"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </v-tabs>
                      </v-toolbar>

                      <v-tabs-items v-model="dateTimeTab">
                        <v-tab-item value="date">
                          <v-date-picker
                            v-model="productBundlePublishDate"
                            @change="updateProductBundlePublishDateTime"
                            class="rounded-0"
                            @input="dateTimeTab = 'time'"
                            full-width
                          >
                          </v-date-picker>
                        </v-tab-item>
                        <v-tab-item value="time">
                          <v-time-picker
                            :key="dateTimeTab"
                            v-model="productBundlePublishTime"
                            format="24hr"
                            class="rounded-0"
                            full-width
                            @change="updateProductBundlePublishDateTime"
                          >
                          </v-time-picker>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-dialog>
                </v-col>

                <v-col cols="12">
                  <v-combobox
                    v-model="editedItemComputedTags"
                    label="Tags"
                    multiple
                    chips
                    append-icon=""
                    :items="productTagNameArray"
                    deletable-chips
                    clearable
                  ></v-combobox>
                </v-col>

                <v-col cols="12">
                  <v-menu
                    v-model="editProductBundleCategoriesMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    :nudge-bottom="-12"
                    :rounded="false"
                  >
                    <template v-slot:activator="{ on }">
                      <div @click="toggleEditProductBundleMenu">
                        <v-combobox
                          class="productBundlesSearchInputCSS pt-2"
                          :value="computedEditProductBundleCategoriesValue"
                          label="Categories"
                          dense
                          min-height="36px"
                          clearable
                          v-on="on"
                          readonly
                          @click:clear="editedItem.categoryId = ''"
                        ></v-combobox>
                      </div>
                    </template>
                    <v-card max-height="200px" class="overflow-y-auto">
                      <v-card-text>
                        <v-treeview
                          :items="categoryTree"
                          color="primary"
                          activatable
                          item-key="id"
                          @update:active="updateProductBundleCategory"
                          :active="[editedItem.categoryId]"
                        ></v-treeview>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedItem.products"
                    :items="nonQuestionProductArray"
                    :disabled="!syncedProducts"
                    :loading="!syncedProducts"
                    item-text="title"
                    item-value="id"
                    :label="`${$i18n.t('headings.products')}*`"
                    required
                    return-object
                    :rules="formRules.products"
                    chips
                    clearable
                    deletable-chips
                    multiple
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <span class="text-h6">Description</span>
                  <RichTextEditor
                    v-model="editedItem.description"
                    :datamodelId="editedItem.id"
                    s3Folder="ProductBundles"
                    s3SubFolder="Description"
                  >
                  </RichTextEditor>
                </v-col>

                <v-col cols="12">
                  <v-card class="px-3 pt-3">
                    <v-row
                      no-gutters
                      justify="space-between"
                      style="gap: 12px"
                      class="pb-3"
                    >
                      <span class="text-h6">Product Bundle Images</span>
                      <v-btn
                        color="primary"
                        @click="uploadThumbnailImage"
                        :disabled="offline || editedIndex === -1 || loading"
                      >
                        {{
                          editedIndex === -1
                            ? "Save product bundle to add images"
                            : "Add Image"
                        }}
                      </v-btn>
                    </v-row>
                    <v-row
                      v-if="thumbnailImagesSrc?.length > 0"
                      no-gutters
                      class="thumbnailvrow"
                      style="margin-top: -12px"
                    >
                      <draggable
                        v-model="editedItem.thumbnails"
                        style="width: 100%"
                        class="d-flex flex-wrap"
                      >
                        <v-col
                          v-for="(
                            thumbnailKey, thumbnailIndex
                          ) in editedItem.thumbnails"
                          :key="thumbnailIndex"
                          cols="12"
                          sm="6"
                          md="4"
                          class="pa-3"
                        >
                          <div
                            @mouseenter="mouseOver(thumbnailIndex)"
                            @mouseleave="mouseOut"
                            class="d-flex justify-center align-center"
                            style="
                              position: relative;
                              border: thin solid;
                              border-radius: 4px;
                              height: 100%;
                              width: 100%;
                            "
                            :style="
                              productBundleImgHoveringIndex === thumbnailIndex
                                ? 'border-color: #ffa9b8;'
                                : ''
                            "
                          >
                            <v-img
                              max-height="100%"
                              max-width="100%"
                              :src="getThumbnailImageSrc(thumbnailKey)"
                              cover
                              style="border-radius: 4px"
                            ></v-img>
                            <!-- <img
                              style="
                                max-width: 100%;
                                max-height: 100%;
                                object-fit: cover;
                                border-radius: 8px;
                              "
                              :src="getThumbnailImageSrc(thumbnailKey)"
                            /> -->

                            <div
                              v-if="
                                productBundleImgHoveringIndex ===
                                  thumbnailIndex && editedIndex !== -1
                              "
                              style="position: absolute; top: 0; right: 0"
                            >
                              <v-menu
                                offset-x
                                v-model="isProductBundleImgMenuOpen"
                              >
                                <template
                                  v-slot:activator="{ on: menu, attrs }"
                                >
                                  <v-btn v-bind="attrs" icon v-on="{ ...menu }">
                                    <v-icon>mdi-cog</v-icon>
                                  </v-btn>
                                </template>
                                <div
                                  class="d-flex flex-column"
                                  style="background-color: white"
                                  @mouseleave="mouseOutMenu"
                                >
                                  <v-btn
                                    text
                                    color="red"
                                    @click="
                                      deleteProductBundleThumbnail(thumbnailKey)
                                    "
                                  >
                                    Remove
                                  </v-btn>
                                </div>
                              </v-menu>
                            </div>
                          </div>
                        </v-col>
                      </draggable>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              :disabled="editedIndex === -1 || productBundleSaved"
              @click="cancelWarning"
            >
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="close" :disabled="loading">
              Close
            </v-btn>
            <v-btn
              :disabled="!valid || productBundleSaved || offline || loading"
              :loading="loading"
              color="primary"
              @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogCancel" max-width="500px">
      <v-card>
        <v-card-title class="justify-center" style="word-break: break-word"
          >Are you sure you want to discard the changes made to this product
          bundle?</v-card-title
        >
        <v-card-actions>
          <v-btn
            color="secondary"
            class="black--text"
            :disabled="cancelingChanges"
            @click="closeCancel"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="cancelingChanges" @click="cancel"
            >YES</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="justify-center"
          >Are you sure you want to delete this product bundle?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="deletingItem" @click="closeDelete"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="deletingItem"
            :disabled="deletingItem"
            @click="deleteItemConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  DataStore,
  Storage,
  SortDirection,
  // , Predicates
} from "aws-amplify";
import { Product, ProductTag, ProductCategory, ProductBundle } from "@/models";
import _ from "lodash";
import draggable from "vuedraggable";
import RichTextEditor from "@/components/global-components/rich-text-editor/RichTextEditor.vue";
import store from "@/store";
// import { getUrl } from "aws-amplify/storage";
import { reconfigureDatastore } from "@/plugins/datastore/config.js";

export default {
  name: "AdminHolidays",
  components: {
    draggable,
    RichTextEditor,
  },
  data: () => ({
    initiallyLoaded: false,

    isProductBundleImgMenuOpen: false,
    productBundleImgHoveringIndex: -1,

    syncedProductBundles: false,
    syncedProductBundleArray: [],

    syncedProductTagArray: [],
    productTagNameArray: [],

    syncedProductCategoryArray: [],

    syncedProducts: false,
    syncedProductArray: [],
    nonQuestionProductArray: [],

    selectedProductBundles: [],
    savingSelectedProductBundles: false,

    //Bulk Edit ------------------
    expBulkEditPanels: 0,

    bulkEditPublishDate: "",
    bulkEditPublishTime: "",
    bulkEditPublishDateTime: null,
    bulkEditDateTimeDialog: false,
    bulkEditDateTimeTab: "date",

    bulkEditPriceChangePercent: null,
    bulkEditPriceChangeValue: null,

    bulkEditDiscountPercent: null,
    //Bulk Edit-END ------------------

    loading: false,
    valid: false,

    datetimeDialog: false,
    dateTimeTab: "date",
    productBundlePublishDate: "",
    productBundlePublishTime: "",

    dialog: false,
    dialogDelete: false,
    dialogCancel: false,

    deletingItem: false,
    cancelingChanges: false,

    sortBy: "title",
    sortDesc: true,
    productBundlesDataTableSearch: "",
    productBundlesDataTableSearchTags: [],
    productBundlesDataTableSearchCategories: [],
    productBundlesDataTablePageCount: 1,
    productBundlesDataTableRowsPerPage: 10,
    productBundlesDataTableServerItemsLength: 0,
    searchProductBundleCategoriesMenu: false,
    editProductBundleCategoriesMenu: false,
    editCategoryParentMenu: false,

    headers: [
      { text: "Title", value: "title" },
      { text: "Price", value: "price" },
      { text: "Featured", value: "featured" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    productBundles: [],
    thumbnailImagesSrc: [],

    editedIndex: -1,

    unEditedProductBundle: {},

    editedItem: {
      title: "",
      description: "",
      price: null,
      discountPercentage: null,
      thumbnails: [],
      tags: [],
      products: [],
      publishDate: null,
      featured: false,
      searchField: "",
      categoryId: "",
    },
    defaultItem: {
      title: "",
      description: "",
      price: null,
      discountPercentage: null,
      thumbnails: [],
      tags: [],
      products: [],
      publishDate: null,
      featured: false,
      searchField: "",
      categoryId: "",
    },

    formRules: {
      title: [(v) => !!v || "Title is required"],
      hint: [(v) => !!v || "Hint is required"],
      placeholder: [(v) => !!v || "Placeholder is required"],
      label: [(v) => !!v || "Label is required"],
    },

    productBundleSearchExcludeFields: [
      "id",
      "thumbnails",
      "searchField",
      "categoryId",
      "createdAt",
      "featured",
      "publishDate",
      "updatedAt",
      "_version",
      "_lastChangedAt",
      "_deleted",
    ],
  }),

  computed: {
    ...mapState({
      offline: (state) => !state.isOnline,
      datastorePredicates: (state) => state.datastorePredicates,
      changingDatastoreConfig: (state) => state.changingDatastoreConfig,
      datastoreReady: (state) => state.datastoreReady,
      startedDatastoreSync: (state) => state.startedDatastoreSync,
      productBundleParams: (state) => state.productBundleParams,
    }),

    categoryTree() {
      // Assuming syncedProductCategoryArray contains flat array of categories
      // with parentId indicating hierarchy, transform it into a tree-like structure
      return this.buildCategoryTree(this.syncedProductCategoryArray);
    },

    computedEditProductBundleCategoriesValue: {
      get: function () {
        const category = this.syncedProductCategoryArray.find(
          (category) => category.id === this.editedItem.categoryId
        );

        if (category) {
          let parentCategories = [];

          if (category.parentId) {
            let currentCategory = category;
            while (currentCategory.parentId) {
              const parentCategory = this.syncedProductCategoryArray.find(
                (category) => category.id === currentCategory.parentId
              );
              if (parentCategory) {
                parentCategories.unshift(parentCategory.name);
                currentCategory = parentCategory;
              } else {
                break;
              }
            }
          }

          return parentCategories.length > 0
            ? parentCategories.join("/") + "/" + category.name
            : category.name;
        } else return "";
      },
    },

    editedItemComputedTags: {
      get: function () {
        const editedItemTags = this.editedItem.tags
          ? this.editedItem.tags
              .map((tagId) => {
                const productBundleTag = this.syncedProductTagArray.find(
                  (tag) => tag.id === tagId
                );

                if (productBundleTag) return productBundleTag.name;
              })
              .filter((tag) => tag !== undefined)
          : [];
        return editedItemTags;
      },
      set: async function (newValue) {
        const updatedTags = [];
        for (const tag of newValue) {
          if (typeof tag === "string") {
            // If tag is a string, it's a new tag
            const existingTag = this.syncedProductTagArray.find(
              (t) => t.name === tag
            );
            if (existingTag) {
              // If tag already exists, push its ID
              updatedTags.push(existingTag.id);
            } else {
              // If tag doesn't exist, create a new ProductTag model
              try {
                const newTag = await DataStore.save(
                  new ProductTag({ name: tag })
                );
                this.productTagNameArray.push(newTag.name);
                updatedTags.push(newTag.id);
              } catch (error) {
                console.error("Error saving new tag:", error);
              }
            }
          }
        }

        this.editedItem.tags = updatedTags;
      },
    },

    productBundlesSearchTags: {
      get: function () {
        let tags = [];
        _.forEach(this.productBundlesDataTableSearchTags, (tagId) => {
          const productBundleTag = _.find(this.syncedProductTagArray, {
            id: tagId,
          });
          if (productBundleTag) {
            tags.push(productBundleTag);
          }
        });
        return tags;
      },
      set: function (newValue) {
        this.productBundlesDataTableSearchTags = newValue;
      },
    },

    computedProductBundlesSearchCategories: {
      get: function () {
        let categories = [];
        _.forEach(
          this.productBundlesDataTableSearchCategories,
          (categoryId) => {
            const category = _.find(this.syncedProductCategoryArray, {
              id: categoryId,
            });
            if (category) {
              let parentCategories = [];

              if (category.parentId) {
                let currentCategory = category;
                while (currentCategory.parentId) {
                  const parentCategory = this.syncedProductCategoryArray.find(
                    (category) => category.id === currentCategory.parentId
                  );
                  if (parentCategory) {
                    parentCategories.unshift(parentCategory.name);
                    currentCategory = parentCategory;
                  } else {
                    break;
                  }
                }
              }

              categories.push(
                parentCategories.length > 0
                  ? parentCategories.join("/") + "/" + category.name
                  : category.name
              );
            }
          }
        );
        return categories;
      },
    },

    formTitle() {
      return this.editedIndex === -1
        ? "New Product Bundle"
        : "Edit Product Bundle";
    },

    formattedProductBundlePublishDate() {
      return this.editedItem.publishDate
        ? new Date(this.editedItem.publishDate).toLocaleString()
        : "";
    },

    formattedBulkEditPublishDate() {
      return this.bulkEditPublishDateTime
        ? new Date(this.bulkEditPublishDateTime).toLocaleString()
        : "";
    },

    productBundleSaved() {
      const equal = _.isEqual(this.editedItem, this.unEditedProductBundle);
      return equal;
    },

    productBundleVat() {
      return this.editedItem.price
        ? Number.parseFloat(
            (this.editedItem.price / (1 + 0.15) - this.editedItem.price) * -1
          ).toFixed(2)
        : 0;
    },
  },

  async mounted() {
    try {
      store.commit("changeDatastorePredicates", [
        {
          model: "Product",
          predicate: "Admin",
        },
        {
          model: "ProductBundle",
          predicate: "Admin",
        },
        {
          model: "ProductTag",
          predicate: "Admin",
        },
        {
          model: "ProductCategory",
          predicate: "Admin",
        },
      ]);

      if (!this.startedDatastoreSync || this.datastoreReady) {
        reconfigureDatastore();
      }

      this.headers = [
        {
          text: "Title",
          value: "title",
        },

        { text: "Featured", value: "featured" },
        {
          text: "Price",
          value: "price",
        },
        {
          text: "Discount",
          value: "discountPercentage",
        },
        {
          text: "Category",
          value: "categoryId",
          sortable: false,
        },
        {
          text: "Publish Date",
          value: "publishDate",
        },
        {
          text: "Modified Date",
          value: "updatedAt",
        },
        { text: "Actions", value: "actions", sortable: false },
      ];

      if (!this.changingDatastoreConfig) {
        await this.syncData();
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (!this.initiallyLoaded) {
        this.initiallyLoaded = true;
      }
    }
  },

  watch: {
    changingDatastoreConfig: {
      async handler(newVal, oldVal) {
        console.log("watch changingDatastoreConfig", newVal, oldVal);

        if (newVal === true) {
          return;
        }

        if (newVal === false) {
          await this.syncData();
        }
      },
      // deep: true,
    },

    productBundleParams: {
      handler(val) {
        console.log("productBundleParams", val);
        if (val) {
          this.createItem();
        }
      },
      // deep: true,
      immediate: true,
    },

    dialog(val) {
      val || this.close();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },

    sortDesc() {
      this.queryProductBundles();
    },

    sortBy() {
      this.queryProductBundles();
    },
  },

  methods: {
    async changeProductBundlesSearchQuery() {
      await this.queryProductBundles();
    },

    // Helper function to recursively collect category IDs
    collectCategoryIds(categoryId) {
      let ids = [];

      // Helper function to traverse categories
      function traverseCategories(currentId) {
        // Add the current category ID to the list
        ids.push(currentId);
        // Find all children whose parentId matches currentId
        const children = this.syncedProductCategoryArray.filter(
          (cat) => cat.parentId === currentId
        );
        // Recursively traverse each child
        children.forEach((child) => traverseCategories.call(this, child.id));
      }

      traverseCategories.call(this, categoryId);

      return ids;
    },

    formatDateTime(date) {
      if (!date) return "";
      return new Date(date).toISOString().replace("T", " ").split("Z")[0];
    },

    async scheduleProductBundles() {
      this.savingSelectedProductBundles = true;

      await _.forEach(
        this.selectedProductBundles,
        async (selectedProductBundle, i) => {
          const immutableProductBundle = _.find(this.syncedProductBundleArray, {
            id: selectedProductBundle.id,
          });
          if (immutableProductBundle) {
            await DataStore.save(
              ProductBundle.copyOf(immutableProductBundle, (updated) => {
                updated.publishDate = this.bulkEditPublishDateTime;
              })
            );
          }

          if (i + 1 === this.selectedProductBundles.length) {
            this.savingSelectedProductBundles = false;
            this.bulkEditPublishDateTime = null;
            this.bulkEditPublishDate = "";
            this.bulkEditPublishTime = "";
            return;
          }
        }
      );
    },

    async unScheduleProductBundles() {
      this.savingSelectedProductBundles = true;

      await _.forEach(
        this.selectedProductBundles,
        async (selectedProductBundle, i) => {
          const immutableProductBundle = _.find(this.syncedProductBundleArray, {
            id: selectedProductBundle.id,
          });
          if (immutableProductBundle) {
            await DataStore.save(
              ProductBundle.copyOf(immutableProductBundle, (updated) => {
                updated.publishDate = null;
              })
            );
          }

          if (i + 1 === this.selectedProductBundles.length) {
            this.savingSelectedProductBundles = false;
            return;
          }
        }
      );
    },

    async changeProductBundlesPrice(incOrDec) {
      this.savingSelectedProductBundles = true;

      await _.forEach(
        this.selectedProductBundles,
        async (selectedProductBundle, i) => {
          const immutableProductBundle = _.find(this.syncedProductBundleArray, {
            id: selectedProductBundle.id,
          });

          const basePrice = immutableProductBundle.price || 0;

          const updatedPrice = parseFloat(
            (this.bulkEditPriceChangeValue
              ? incOrDec === "increase"
                ? basePrice + parseFloat(this.bulkEditPriceChangeValue)
                : basePrice - parseFloat(this.bulkEditPriceChangeValue)
              : incOrDec === "increase"
              ? basePrice +
                (basePrice * parseFloat(this.bulkEditPriceChangePercent)) / 100
              : basePrice -
                (basePrice * parseFloat(this.bulkEditPriceChangePercent)) / 100
            ).toFixed(2)
          );

          const newPrice =
            updatedPrice <= 0 && !immutableProductBundle.price
              ? null
              : updatedPrice <= 0
              ? 0
              : updatedPrice;

          // console.log("newPrice", newPrice);

          if (immutableProductBundle) {
            await DataStore.save(
              ProductBundle.copyOf(immutableProductBundle, (updated) => {
                updated.price = newPrice;
              })
            );
          }

          if (i + 1 === this.selectedProductBundles.length) {
            this.bulkEditPriceChangePercent = null;
            this.bulkEditPriceChangeValue = null;
            this.savingSelectedProductBundles = false;
            return;
          }
        }
      );
    },

    async discountProductBundles() {
      this.savingSelectedProductBundles = true;

      await _.forEach(
        this.selectedProductBundles,
        async (selectedProductBundle, i) => {
          const immutableProductBundle = _.find(this.syncedProductBundleArray, {
            id: selectedProductBundle.id,
          });

          const basePrice = immutableProductBundle.price || 0;

          const discount =
            basePrice === 0 || this.bulkEditDiscountPercent === "0"
              ? null
              : parseFloat(this.bulkEditDiscountPercent);

          console.log("discount", discount);

          if (immutableProductBundle) {
            await DataStore.save(
              ProductBundle.copyOf(immutableProductBundle, (updated) => {
                updated.discountPercentage = discount;
              })
            );
          }

          if (i + 1 === this.selectedProductBundles.length) {
            this.bulkEditDiscountPercent = null;
            this.savingSelectedProductBundles = false;
            return;
          }
        }
      );
    },

    async featureProductBundles() {
      this.savingSelectedProductBundles = true;

      await _.forEach(
        this.selectedProductBundles,
        async (selectedProductBundle, i) => {
          const immutableProductBundle = _.find(this.syncedProductBundleArray, {
            id: selectedProductBundle.id,
          });
          if (
            immutableProductBundle &&
            immutableProductBundle.featured !== true
          ) {
            await DataStore.save(
              ProductBundle.copyOf(immutableProductBundle, (updated) => {
                updated.featured = true;
              })
            );
          } else if (i + 1 === this.selectedProductBundles.length) {
            this.savingSelectedProductBundles = false;
            return;
          }

          if (i + 1 === this.selectedProductBundles.length) {
            this.savingSelectedProductBundles = false;
          }
        }
      );
    },

    async unFeatureProductBundles() {
      this.savingSelectedProductBundles = true;

      await _.forEach(
        this.selectedProductBundles,
        async (selectedProductBundle, i) => {
          const immutableProductBundle = _.find(this.syncedProductBundleArray, {
            id: selectedProductBundle.id,
          });
          if (
            immutableProductBundle &&
            immutableProductBundle.featured !== false
          ) {
            await DataStore.save(
              ProductBundle.copyOf(immutableProductBundle, (updated) => {
                updated.featured = false;
              })
            );
          } else if (i + 1 === this.selectedProductBundles.length) {
            this.savingSelectedProductBundles = false;
            return;
          }

          if (i + 1 === this.selectedProductBundles.length) {
            this.savingSelectedProductBundles = false;
          }
        }
      );
    },

    updateProductBundleCategory(val) {
      this.editedItem.categoryId = val.length > 0 ? val[0] : "";
    },

    toggleMenu() {
      this.searchProductBundleCategoriesMenu =
        !this.searchProductBundleCategoriesMenu;
    },

    toggleEditProductBundleMenu() {
      this.editProductBundleCategoriesMenu =
        !this.editProductBundleCategoriesMenu;
    },

    buildCategoryTree(categories, propCategoryId) {
      let tree = [];

      // Create a map of categories by their ID for quicker access
      const categoryMap = {};
      categories.forEach((category) => {
        categoryMap[category.id] = { ...category, children: [] };
      });

      // Function to recursively build the tree
      const buildTree = (categoryId) => {
        const category = categoryMap[categoryId];
        if (!category) return null; // Return null if category not found

        // Check if the category meets the condition to be added to the tree
        if (propCategoryId > "" && category.id === propCategoryId) {
          // Skip adding this category and its children
          return;
        }

        // Recursively build children
        if (category.parentId) {
          const parentCategory = categoryMap[category.parentId];
          if (parentCategory) {
            parentCategory.children.push(category);
          }
        } else {
          tree.push(category); // Add to top-level tree if no parent
        }
      };

      // Build tree for each category
      categories.forEach((category) => {
        buildTree(category.id);
      });

      return tree;
    },

    updateProductBundlePublishDateTime(action) {
      if (action === "clear") {
        this.productBundlePublishDate = null;
        this.productBundlePublishTime = null;
        this.editedItem.publishDate = null;
      } else if (
        this.productBundlePublishDate &&
        this.productBundlePublishTime
      ) {
        this.editedItem.publishDate = new Date(
          new Date(
            this.productBundlePublishDate +
              "T" +
              this.productBundlePublishTime +
              ":00Z"
          ).getTime() -
            2 * 60 * 60 * 1000
        ).toISOString();
      } else {
        this.editedItem.publishDate = null;
      }
    },

    updateBulkEditPublishDateTime(action) {
      if (action === "clear") {
        this.bulkEditPublishDate = null;
        this.bulkEditPublishTime = null;
        this.bulkEditPublishDateTime = null;
      } else if (this.bulkEditPublishDate && this.bulkEditPublishTime) {
        this.bulkEditPublishDateTime = new Date(
          new Date(
            this.bulkEditPublishDate + "T" + this.bulkEditPublishTime + ":00Z"
          ).getTime() -
            2 * 60 * 60 * 1000
        ).toISOString();
      } else {
        this.bulkEditPublishDateTime = null;
      }
    },

    closeDateTimeDialog() {
      this.datetimeDialog = false;
      this.dateTimeTab = "date";
    },

    closeBulkEditDateTimeDialog() {
      this.bulkEditDateTimeDialog = false;
      this.bulkEditDateTimeTab = "date";
    },

    cancelWarning() {
      this.dialogCancel = true;
    },

    productBundlesDataTablePageCountUpdate(val) {
      if (val !== 0) {
        this.productBundlesDataTablePageCount = val; // Convert to 0-based index
        this.queryProductBundles();
      }
    },

    formatPercentage(percent) {
      // Ensure the price is a valid number
      if (percent === null || percent === undefined || isNaN(percent)) {
        return "";
      }

      return `${percent}%`;
    },

    formatPrice(price) {
      // Ensure the price is a valid number
      if (price === null || price === undefined || isNaN(price)) {
        return "";
      }

      // Convert the price to a fixed-point notation with 2 decimals
      const formattedPrice = parseFloat(price).toFixed(2);

      return `R ${formattedPrice}`;
    },

    formatCategoryId(categoryId) {
      const category = this.syncedProductCategoryArray.find(
        (category) => category.id === categoryId
      );

      if (category) {
        let parentCategories = [];

        if (category.parentId) {
          let currentCategory = category;
          while (currentCategory.parentId) {
            const parentCategory = this.syncedProductCategoryArray.find(
              (category) => category.id === currentCategory.parentId
            );
            if (parentCategory) {
              parentCategories.unshift(parentCategory.name);
              currentCategory = parentCategory;
            } else {
              break;
            }
          }
        }

        return parentCategories.length > 0
          ? parentCategories.join("/") + "/" + category.name
          : category.name;
      } else return "";
    },

    async deleteProductBundleThumbnail(thumbnailKey) {
      // console.log("deleteProductBundleThumbnail:", thumbnailKey);
      await Storage.remove(thumbnailKey, {
        level: "public",
      })
        .then(() => {
          const mutableThumbnails = _.cloneDeep(this.editedItem.thumbnails);
          _.remove(
            mutableThumbnails,
            (thumbnail) => thumbnail === thumbnailKey
          );
          this.editedItem.thumbnails = mutableThumbnails;

          _.remove(
            this.thumbnailImagesSrc,
            (thumbnail) => thumbnail.key === thumbnailKey
          );

          this.editedItem.searchField = JSON.stringify(
            _.values(
              _.omit(this.editedItem, this.productBundleSearchExcludeFields)
            )
          ).toLowerCase();

          DataStore.save(
            ProductBundle.copyOf(
              _.find(this.syncedProductBundleArray, { id: this.editedItem.id }),
              (productBundle) => {
                productBundle.thumbnails = this.editedItem.thumbnails;
                productBundle.searchField = this.editedItem.searchField;
              }
            )
          );
        })
        .catch((err) => console.log(err));
    },

    mouseOver(index) {
      if (!this.isProductBundleImgMenuOpen) {
        this.productBundleImgHoveringIndex = index;
      }
    },

    mouseOut() {
      if (!this.isProductBundleImgMenuOpen) {
        this.productBundleImgHoveringIndex = -1;
      }
    },

    mouseOutMenu() {
      this.isProductBundleImgMenuOpen = false;
      this.productBundleImgHoveringIndex = -1;
    },

    getThumbnailImageSrc(thumbnailKey) {
      const thumbnailImgSrc = _.find(this.thumbnailImagesSrc, {
        key: thumbnailKey,
      });
      return thumbnailImgSrc ? thumbnailImgSrc.src : "";
    },

    async getThumbnailImage(productBundleThumbnailkey) {
      const thumbnailImgSrc = await Storage.get(productBundleThumbnailkey, {
        level: "public",
      });
      return thumbnailImgSrc;
    },

    async uploadThumbnailImage() {
      try {
        const inputElement = document.createElement("input");
        inputElement.type = "file";
        inputElement.accept = "image/*";
        // inputElement.multiple = true; // Allow multiple files to be selected

        inputElement.addEventListener("change", async (event) => {
          if (
            event.target instanceof HTMLInputElement &&
            event.target.files &&
            event.target.files.length > 0
          ) {
            this.loading = true;
            const file = event.target.files[0];
            const maxSize = 800; // Define your maximum size here

            // Create a function to resize the image
            const resizeImage = (image) => {
              return new Promise((resolve) => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                const img = new Image();
                img.onload = () => {
                  let width = img.width;
                  let height = img.height;

                  if (width > height) {
                    if (width > maxSize) {
                      height *= maxSize / width;
                      width = maxSize;
                    }
                  } else {
                    if (height > maxSize) {
                      width *= maxSize / height;
                      height = maxSize;
                    }
                  }

                  canvas.width = width;
                  canvas.height = height;

                  ctx.drawImage(img, 0, 0, width, height);

                  canvas.toBlob(
                    (blob) => {
                      resolve(blob);
                    },
                    "image/jpeg",
                    0.9
                  ); // You can change the format and quality here
                };

                img.src = URL.createObjectURL(image);
              });
            };

            const resizedBlob = await resizeImage(file);

            // Upload the resized file to S3
            const newThumbnailImgPut = await Storage.put(
              "ProductBundles/" +
                this.editedItem.id +
                "/Thumbnails/" +
                Date.now() +
                "-" +
                file.name,
              resizedBlob
            ).catch((err) => console.log(err));

            if (!this.editedItem.thumbnails) {
              this.editedItem.thumbnails = [];
            }

            if (!this.editedItem.thumbnails.includes(newThumbnailImgPut.key)) {
              const mutableThumbnails = _.cloneDeep(this.editedItem.thumbnails);

              mutableThumbnails.push(newThumbnailImgPut.key);
              this.editedItem.thumbnails = mutableThumbnails;

              // Fetch the image source for the newly added thumbnail
              const thumbnailImgSrc = await this.getThumbnailImage(
                newThumbnailImgPut.key
              );

              // Update the thumbnailImagesSrc array with the new source
              this.thumbnailImagesSrc.push({
                key: newThumbnailImgPut.key,
                src: thumbnailImgSrc,
              });

              this.editedItem.searchField = JSON.stringify(
                _.values(
                  _.omit(this.editedItem, this.productBundleSearchExcludeFields)
                )
              ).toLowerCase();

              await DataStore.save(
                ProductBundle.copyOf(
                  _.find(this.syncedProductBundleArray, {
                    id: this.editedItem.id,
                  }),
                  (productBundle) => {
                    productBundle.thumbnails = this.editedItem.thumbnails;
                    productBundle.searchField = this.editedItem.searchField;
                  }
                )
              )
                .catch((err) => {
                  console.log(err);
                })
                .then(() => {
                  this.unEditedProductBundle.thumbnails = _.cloneDeep(
                    this.editedItem.thumbnails
                  );
                  this.unEditedProductBundle.searchField =
                    this.editedItem.searchField;
                });
            }

            this.loading = false;
          }
        });

        document.body.appendChild(inputElement);
        inputElement.click();
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    resetForm() {
      if (this.$refs.form) this.$refs.form.reset();
      this.editedItem = _.cloneDeep(this.defaultItem);
      this.valid = false;
    },

    createItem() {
      this.resetForm();

      this.editedItem.searchField = JSON.stringify(
        _.values(_.omit(this.editedItem, this.productBundleSearchExcludeFields))
      ).toLowerCase();

      this.editedItem.publishDate = new Date().toISOString();

      this.productBundlePublishDate = this.editedItem.publishDate.substring(
        0,
        10
      );

      this.productBundlePublishTime = new Date(
        new Date(this.editedItem.publishDate).getTime() + 2 * 60 * 60 * 1000
      )
        .toISOString()
        .substring(11, 16);

      this.dialog = true;
    },

    async duplicateItem(item) {
      try {
        this.loading = true;

        const dupEditedItem = _.cloneDeep(item);

        dupEditedItem.thumbnails = [];

        dupEditedItem.searchField = JSON.stringify(
          _.values(_.omit(dupEditedItem, this.productBundleSearchExcludeFields))
        ).toLowerCase();

        const newProductBundle = await DataStore.save(
          new ProductBundle({
            title: dupEditedItem.title.trim() + " - COPY",
            description: dupEditedItem.description
              ? dupEditedItem.description.trim()
              : "",
            price:
              typeof dupEditedItem.price === "string"
                ? parseFloat(dupEditedItem.price)
                : dupEditedItem.price,
            discountPercentage:
              typeof dupEditedItem.discountPercentage === "string"
                ? parseFloat(dupEditedItem.discountPercentage)
                : dupEditedItem.discountPercentage,
            thumbnails: [],
            tags: dupEditedItem.tags?.length > 0 ? dupEditedItem.tags : [],
            products:
              dupEditedItem.products?.length > 0 ? dupEditedItem.products : [],
            publishDate: dupEditedItem.publishDate,
            featured: dupEditedItem.featured,
            searchField: dupEditedItem.searchField,
            categoryId: dupEditedItem.categoryId,
          })
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async editItem(item) {
      // console.log("editItem:", item);

      this.editedIndex = this.productBundles.indexOf(item);

      this.editedItem = _.cloneDeep(item);

      if (item.thumbnails) {
        item.thumbnails.forEach(async (thumbnailKey) => {
          if (!_.find(this.thumbnailImagesSrc, { key: thumbnailKey })) {
            const thumbnailImgSrc = await this.getThumbnailImage(thumbnailKey);
            this.thumbnailImagesSrc.push({
              key: thumbnailKey,
              src: thumbnailImgSrc,
            });
          }
        });
      }
      if (item.publishDate) {
        this.productBundlePublishDate = item.publishDate.substring(0, 10);
        this.productBundlePublishTime = new Date(
          new Date(item.publishDate).getTime() + 2 * 60 * 60 * 1000
        )
          .toISOString()
          .substring(11, 16);
      }

      this.unEditedProductBundle = _.cloneDeep(this.editedItem);
      this.dialog = true;
    },

    deleteItem(item) {
      const itemToDelete = this.syncedProductBundleArray.find(
        (productBundle) => productBundle.id === item.id
      );
      if (!itemToDelete) return;
      this.editedIndex = this.syncedProductBundleArray.indexOf(itemToDelete);
      this.editedItem = _.cloneDeep(item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.deletingItem = true;
      try {
        // this.productBundles.splice(this.editedIndex, 1);
        await DataStore.delete(this.syncedProductBundleArray[this.editedIndex]);

        for (const thumbnailKey of this.editedItem.thumbnails) {
          await Storage.remove(thumbnailKey, {
            level: "public",
          });
        }
      } catch (error) {
        console.log(error);
      }

      this.deletingItem = false;
      this.closeDelete();
    },

    async cancel() {
      this.cancelingChanges = true;

      try {
        this.thumbnailImagesSrc.forEach(async (thumbnailImgSrc) => {
          const thumbnailKey = thumbnailImgSrc.key;

          if (!this.unEditedProductBundle.thumbnails.includes(thumbnailKey)) {
            _.remove(this.thumbnailImagesSrc, { key: thumbnailKey });

            await Storage.remove(thumbnailKey, {
              level: "public",
            });
          }
        });

        if (this.unEditedProductBundle.thumbnails) {
          this.unEditedProductBundle.thumbnails.forEach(
            async (thumbnailKey) => {
              if (!_.find(this.thumbnailImagesSrc, { key: thumbnailKey })) {
                const thumbnailImgSrc = await this.getThumbnailImage(
                  thumbnailKey
                );
                this.thumbnailImagesSrc.push({
                  key: thumbnailKey,
                  src: thumbnailImgSrc,
                });
              }
            }
          );
        }

        this.editedItem = _.cloneDeep(this.unEditedProductBundle);

        this.editedItem.searchField = JSON.stringify(
          _.values(
            _.omit(this.editedItem, this.productBundleSearchExcludeFields)
          )
        ).toLowerCase();

        await DataStore.save(
          ProductBundle.copyOf(
            _.find(this.syncedProductBundleArray, { id: this.editedItem.id }),
            (updateModel) => {
              (updateModel.title = this.editedItem.title.trim()),
                (updateModel.description = this.editedItem.description
                  ? this.editedItem.description.trim()
                  : ""),
                (updateModel.price =
                  typeof this.editedItem.price === "string"
                    ? parseFloat(this.editedItem.price)
                    : this.editedItem.price),
                (updateModel.discountPercentage =
                  typeof this.editedItem.discountPercentage === "string"
                    ? parseFloat(this.editedItem.discountPercentage)
                    : this.editedItem.discountPercentage),
                (updateModel.thumbnails = this.editedItem.thumbnails),
                (updateModel.tags =
                  this.editedItem.tags?.length > 0 ? this.editedItem.tags : []),
                (updateModel.products =
                  this.editedItem.products?.length > 0
                    ? this.editedItem.products
                    : []),
                (updateModel.publishDate = this.editedItem.publishDate),
                (updateModel.featured = this.editedItem.featured),
                (updateModel.searchField = this.editedItem.searchField),
                (updateModel.categoryId = this.editedItem.categoryId);
            }
          )
        );
      } catch (error) {
        console.log(error);
      }

      this.$nextTick(() => {
        this.dialogCancel = false;
        this.cancelingChanges = false;
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = _.cloneDeep(this.defaultItem);
        this.editedIndex = -1;
        this.thumbnailImagesSrc = _.cloneDeep([]);
        this.productBundlePublishDate = "";
        this.productBundlePublishTime = "";
        this.unEditedProductBundle = {};
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = _.cloneDeep(this.defaultItem);
        this.editedIndex = -1;
        this.thumbnailImagesSrc = _.cloneDeep([]);
        this.productBundlePublishDate = "";
        this.productBundlePublishTime = "";
      });
    },

    closeCancel() {
      this.dialogCancel = false;
    },

    async save() {
      this.loading = true;
      if (this.editedIndex > -1) {
        // Update schedule
        await this.updateProductBundle();
      } else {
        // Create new schedule
        await this.createProductBundle();
      }

      this.unEditedProductBundle = _.cloneDeep(this.editedItem);

      this.$nextTick(() => {
        this.loading = false;
      });
    },

    async createProductBundle() {
      try {
        this.editedItem.searchField = JSON.stringify(
          _.values(
            _.omit(this.editedItem, this.productBundleSearchExcludeFields)
          )
        ).toLowerCase();

        const newProductBundle = await DataStore.save(
          new ProductBundle({
            title: this.editedItem.title.trim(),
            description: this.editedItem.description
              ? this.editedItem.description.trim()
              : "",
            price:
              typeof this.editedItem.price === "string"
                ? parseFloat(this.editedItem.price)
                : this.editedItem.price,
            discountPercentage:
              typeof this.editedItem.discountPercentage === "string"
                ? parseFloat(this.editedItem.discountPercentage)
                : this.editedItem.discountPercentage,
            thumbnails: [],
            tags: this.editedItem.tags?.length > 0 ? this.editedItem.tags : [],
            products:
              this.editedItem.products?.length > 0
                ? this.editedItem.products
                : [],
            publishDate: this.editedItem.publishDate,
            featured: this.editedItem.featured,
            searchField: this.editedItem.searchField,
            categoryId: this.editedItem.categoryId,
          })
        );

        this.editedItem.id = newProductBundle.id;
        this.editedIndex = 0;
      } catch (error) {
        console.log(error);
      }
    },

    async updateProductBundle() {
      try {
        this.editedItem.searchField = JSON.stringify(
          _.values(
            _.omit(this.editedItem, this.productBundleSearchExcludeFields)
          )
        ).toLowerCase();

        await DataStore.save(
          ProductBundle.copyOf(
            _.find(this.syncedProductBundleArray, { id: this.editedItem.id }),
            (updateModel) => {
              (updateModel.title = this.editedItem.title.trim()),
                (updateModel.description = this.editedItem.description
                  ? this.editedItem.description.trim()
                  : ""),
                (updateModel.price =
                  typeof this.editedItem.price === "string"
                    ? parseFloat(this.editedItem.price)
                    : this.editedItem.price),
                (updateModel.discountPercentage =
                  typeof this.editedItem.discountPercentage === "string"
                    ? parseFloat(this.editedItem.discountPercentage)
                    : this.editedItem.discountPercentage),
                (updateModel.thumbnails = this.editedItem.thumbnails),
                (updateModel.tags =
                  this.editedItem.tags?.length > 0 ? this.editedItem.tags : []),
                (updateModel.products =
                  this.editedItem.products?.length > 0
                    ? this.editedItem.products
                    : []),
                (updateModel.publishDate = this.editedItem.publishDate),
                (updateModel.featured = this.editedItem.featured),
                (updateModel.searchField = this.editedItem.searchField),
                (updateModel.categoryId = this.editedItem.categoryId);
            }
          )
        );
      } catch (error) {
        console.log(error);
      }
    },

    async queryProductBundles() {
      try {
        const search = this.productBundlesDataTableSearch.split(" ");
        this.selectedProductBundles = [];

        const productBundleCount = (
          await DataStore.query(ProductBundle, (productBundle) =>
            productBundle.and((f) => [
              this.productBundlesDataTableSearchTags.every((tag) =>
                f.tags("contains", tag)
              ),
              f.or((f) =>
                this.productBundlesDataTableSearchCategories.reduce(
                  (c, id) => c.categoryId("eq", id),
                  f
                )
              ),
              search
                .map((str) => str.toLowerCase())
                .every((string) => f.searchField("contains", string)),
            ])
          )
        ).length;

        this.productBundlesDataTableServerItemsLength = productBundleCount || 0;

        const filterObj = {
          page: this.productBundlesDataTablePageCount - 1,
          limit: this.productBundlesDataTableRowsPerPage,
          sort: (s) =>
            s[this.sortBy](
              this.sortDesc ? SortDirection.DESCENDING : SortDirection.ASCENDING
            ),
        };

        if (this.productBundlesDataTableRowsPerPage === -1) {
          delete filterObj.page;
          delete filterObj.limit;
        }

        const queriedProductBundles = await DataStore.query(
          ProductBundle,
          (productBundle) =>
            productBundle.and((f) => [
              this.productBundlesDataTableSearchTags.every((tag) =>
                f.tags("contains", tag)
              ),
              f.or((f) =>
                this.productBundlesDataTableSearchCategories.reduce(
                  (c, id) => c.categoryId("eq", id),
                  f
                )
              ),
              search
                .map((str) => str.toLowerCase())
                .every((string) => f.searchField("contains", string)),
            ]),
          filterObj
        );

        this.syncedProductBundleArray = queriedProductBundles;

        // this.productBundles = _.cloneDeep(productBundles);

        // Loop through queriedProductBundles to update or add new productBundles
        queriedProductBundles.forEach((newProductBundle) => {
          // console.log("newProductBundle:", newProductBundle);
          const existingProductBundleIndex = this.productBundles.findIndex(
            (productBundle) => productBundle.id === newProductBundle.id
          );
          // console.log("existingProductBundleIndex:", existingProductBundleIndex);

          if (existingProductBundleIndex !== -1) {
            const existingProductBundle =
              this.productBundles[existingProductBundleIndex];

            if (
              existingProductBundle.updatedAt !== newProductBundle.updatedAt
            ) {
              // Update the productBundle while preserving thumbnailImages
              const updatedProductBundle = {
                ...newProductBundle,
                thumbnailImages: existingProductBundle.thumbnailImages,
              };
              this.productBundles.splice(
                existingProductBundleIndex,
                1,
                updatedProductBundle
              );
            }
          } else {
            // If new productBundle doesn't exist in this.productBundles, add it
            this.productBundles.push({
              ...newProductBundle,
              thumbnailImages: [],
            });
          }
        });

        // // Remove productBundles not in sortedProductBundles
        this.productBundles = this.productBundles.filter((productBundle) =>
          queriedProductBundles.some(
            (newProductBundle) => newProductBundle.id === productBundle.id
          )
        );

        this.productBundles = _.sortBy(this.productBundles, [
          (p) => p.featured || false,
          (p) => new Date(p.publishDate),
          (p) => p.title,
        ]).reverse();
      } catch (error) {
        console.log(error);
      }
    },

    syncData() {
      console.log("Syncing data...ADMINPRODUCTBUNDLES");

      try {
        this.syncProductBundles();

        const productSubscription = DataStore.observeQuery(Product).subscribe(
          async (snapshot) => {
            const { isSynced, items } = snapshot;
            if (
              // isSynced &&
              !_.isEqual(items, this.syncedProductArray)
            ) {
              this.syncedProductArray = items;
              this.nonQuestionProductArray = items
                .filter(
                  (product) =>
                    !product.questions || product.questions?.length === 0
                )
                .map((product) => ({ id: product.id, title: product.title }));
            }

            const productBundleParams = this.productBundleParams;

            if (isSynced) {
              this.syncedProducts = true;

              if (productBundleParams) {
                this.editedItem = {
                  ...this.editedItem,
                  ...productBundleParams,
                };

                if (productBundleParams.products) {
                  // console.log("params.products", productBundleParams.products);

                  const nonQuestionProducts = this.syncedProductArray
                    .filter(
                      (product) =>
                        productBundleParams.products.includes(product.id) &&
                        (!product.questions || product.questions?.length === 0)
                    )
                    .map((product) => ({
                      id: product.id,
                      title: product.title,
                    }));

                  // console.log("nonQuestionProductIDs", nonQuestionProductIDs);
                  this.editedItem.products = nonQuestionProducts;
                }

                store.commit("changeProductBundleParams", null);
              }
            } else if (!isSynced) {
              this.syncedProducts = false;
            }
          },
          (error) => {
            console.log(error);
          }
        );

        const tagSubscription = DataStore.observeQuery(ProductTag).subscribe(
          async (snapshot) => {
            const { isSynced, items } = snapshot;
            if (
              // isSynced &&
              !_.isEqual(items, this.syncedProductTagArray)
            ) {
              this.syncedProductTagArray = items;
              this.productTagNameArray = items.map((tag) => {
                return tag.name;
              });
            }
          },
          (error) => {
            console.log(error);
          }
        );

        const categorySubscription = DataStore.observeQuery(
          ProductCategory
        ).subscribe(
          async (snapshot) => {
            const { isSynced, items } = snapshot;
            if (
              // isSynced &&
              !_.isEqual(items, this.syncedProductCategoryArray)
            ) {
              this.syncedProductCategoryArray = items;
              // this.productCategoryNameArray = items.map((category) => {
              //   return category.name;
              // });
            }
          },
          (error) => {
            console.log(error);
          }
        );

        store.commit("addSubscriptions", [
          { model: "ProductTag", sub: tagSubscription },
          { model: "ProductCategory", sub: categorySubscription },
          { model: "Product", sub: productSubscription },
        ]);
      } catch (error) {
        console.log(error);
      }
    },

    syncProductBundles() {
      const productBundleSubscription = DataStore.observeQuery(
        ProductBundle
      ).subscribe(
        async (snapshot) => {
          const { isSynced, items } = snapshot;

          if (items?.length > 0 && !this.changingDatastoreConfig) {
            console.log("Synced productBundles queryProductbundles");
            await this.queryProductBundles();
          }

          if (isSynced) {
            this.syncedProductBundles = true;
          } else {
            this.syncedProductBundles = false;
          }
        },
        (error) => {
          console.log(error);
        }
      );

      store.commit("addSubscription", {
        model: "ProductBundle",
        sub: productBundleSubscription,
      });
    },
  },

  beforeDestroy() {
    store.commit("removeSubscriptions", [
      "Product",
      "ProductBundle",
      "ProductTag",
      "ProductCategory",
      "ProductContent",
    ]);

    store.commit("removeDatastorePredicates", [
      "Product",
      "ProductBundle",
      "ProductTag",
      "ProductCategory",
      "ProductContent",
    ]);
  },
};
</script>

<style>
.productBundlesSearchInputCSS .v-input__slot {
  margin-bottom: 0px !important;
}

.productBundlesSearchInputCSS .v-select__selections {
  min-height: 36px !important;
}

.thumbnailvrow {
  margin-left: -12px;
  margin-right: -12px;
}

/* #productBundlesDataTable .v-data-footer__pagination {
  visibility: hidden;
}
#productBundlesDataTable .v-data-footer__select {
  visibility: hidden;
} */

.t-datetime-picker {
  .v-tabs-slider-wrapper {
    top: 0;
  }
  .v-picker__title {
    height: 90px;
  }
  .v-time-picker-title__time * {
    font-size: 60px;
    height: 60px;
  }
  .v-picker__body {
    height: 290px;
  }
  .v-tabs-items {
    height: 380px;
  }
}

#expPanelContent > * {
  padding: 12px !important;
}

.plannerPanelTopBorder > div:nth-child(2) {
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel:first-child {
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel--active + div {
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel:last-child {
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel--next-active {
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel--active {
  border-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel--active #expPanelContent {
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}
</style>
